import './style/index.js';

import _Slider from './Slider';

export type { SliderProps } from './Slider';
export * from './type';

export const Slider = _Slider;
export default Slider;
